import _ from 'lodash'
import { getDepartment, getDepartments } from './departments-service'
import { getStyleOptions } from './department-styles-service'
import { getCategoryStyles as inheritedStyles } from '../menu-inner-overrides'
import { getActive } from './active-items-util'

export function getAllCategories (menuBlob) {
  return getDepartments(menuBlob)
    .map(department => department.categories.map(it => ({ ...it, departmentId: department.id })))
    .reduce((acc, it) => [...acc, ...it], [])
}

export function getAllActiveCategories (menuBlob) {
  return getActive(getAllCategories(menuBlob))
}

export function getCategories (departmentId, menuBlob) {
  return _.get(getDepartment(departmentId, menuBlob), 'categories', [])
}

export function getCategory (categoryId, departmentId, menuBlob) {
  return getCategories(departmentId, menuBlob).find(it => it.id === categoryId)
}

export function findCategory (categoryId, menuBlob) {
  for (const department of getDepartments(menuBlob)) {
    const category = department.categories.find(it => it.id === categoryId)

    if (category) {
      return category
    }
  }
}

export function getVisibleCategoryStyleOptions (styleId, categoryId, departmentId, menuBlob) {
  const disabledOptions = _.get(getCategoryStyles(categoryId, departmentId, menuBlob), 'disabled', [])

  return getStyleOptions(departmentId, styleId, menuBlob)
    .filter(option => !disabledOptions.find(next => next.styleId === styleId && next.optionId === option.id))
}

function getCategoryStyles (categoryId, departmentId, menuBlob) {
  const category = getCategory(categoryId, departmentId, menuBlob)
  return _.has(category, 'styles') ? category.styles : inheritedStyles(getDepartment(departmentId, menuBlob))
}
